/**
 * Safely parses a localStorage token value.
 * Returns null (and clears the bad value) if the string is a raw JWT
 * or any other non-JSON value.
 */
export function parseStoredToken(raw: string | null): Record<string, any> | null {
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === 'object') return parsed;
    return null;
  } catch {
    return null;
  }
}
